/**
 * 会员管理系统 - 枚举类型定义
 * 
 * 包含所有会员管理相关的枚举类型和中文映射
 */

/**
 * 功能分类
 * 注意：枚举值必须与后端保持一致（小写）
 */
export enum FeatureCategory {
  SPEAKING = 'speaking',
  WRITING = 'writing',
  LISTENING = 'listening',
  READING = 'reading',
  MOCK = 'mock',
  COMMON = 'common',
}

/**
 * 配额类型
 * 注意：枚举值必须与后端保持一致（大写）
 */
export enum QuotaType {
  BOOLEAN = 'BOOLEAN',
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  UNLIMITED = 'UNLIMITED',
}

/**
 * 套餐周期类型
 * 注意：枚举值必须与后端保持一致（大写）
 */
export enum DurationType {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
  CUSTOM = 'CUSTOM',
}

/**
 * 应用名称
 * 注意：枚举值必须与后端保持一致（小写）
 */
export enum AppName {
  HOME = 'home',
  MOCK = 'mock',
  AIC = 'aic',
  UNIAPP = 'uniapp',
  DICTATION = 'dictation',
}

/**
 * 功能分类中文映射
 */
export const FeatureCategoryLabels: Record<FeatureCategory, string> = {
  [FeatureCategory.SPEAKING]: '口语',
  [FeatureCategory.WRITING]: '写作',
  [FeatureCategory.LISTENING]: '听力',
  [FeatureCategory.READING]: '阅读',
  [FeatureCategory.MOCK]: '模考',
  [FeatureCategory.COMMON]: '通用',
}

/**
 * 配额类型中文映射
 */
export const QuotaTypeLabels: Record<QuotaType, string> = {
  [QuotaType.BOOLEAN]: '布尔值',
  [QuotaType.DAILY]: '每日',
  [QuotaType.MONTHLY]: '每月',
  [QuotaType.YEARLY]: '每年',
  [QuotaType.UNLIMITED]: '无限制',
}

/**
 * 套餐周期类型中文映射
 */
export const DurationTypeLabels: Record<DurationType, string> = {
  [DurationType.MONTHLY]: '月卡',
  [DurationType.QUARTERLY]: '季卡',
  [DurationType.YEARLY]: '年卡',
  [DurationType.CUSTOM]: '自定义',
}

/**
 * 应用名称中文映射
 */
export const AppNameLabels: Record<AppName, string> = {
  [AppName.HOME]: '主站',
  [AppName.MOCK]: '模考',
  [AppName.AIC]: 'AI 批改',
  [AppName.UNIAPP]: '小程序',
  [AppName.DICTATION]: '听写',
}

/**
 * 重置周期选项
 */
export const ResetPeriodOptions = [
  { value: 'DAILY', label: '每日' },
  { value: 'MONTHLY', label: '每月' },
  { value: 'YEARLY', label: '每年' },
]

/**
 * 获取功能分类选项（用于下拉选择）
 */
export const getFeatureCategoryOptions = () => {
  return Object.values(FeatureCategory).map((value) => ({
    value,
    label: FeatureCategoryLabels[value],
  }))
}

/**
 * 获取配额类型选项（用于下拉选择）
 */
export const getQuotaTypeOptions = () => {
  return Object.values(QuotaType).map((value) => ({
    value,
    label: QuotaTypeLabels[value],
  }))
}

/**
 * 获取套餐周期类型选项（用于下拉选择）
 */
export const getDurationTypeOptions = () => {
  return Object.values(DurationType).map((value) => ({
    value,
    label: DurationTypeLabels[value],
  }))
}

/**
 * 获取应用名称选项（用于下拉选择）
 */
export const getAppNameOptions = () => {
  return Object.values(AppName).map((value) => ({
    value,
    label: AppNameLabels[value],
  }))
}

